var _rect, _path, _path2, _path3, _path4, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 288,
    viewBox: "0 0 289 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 117.948,
    y: 117,
    width: 54,
    height: 54,
    rx: 7,
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.216 153C143.392 153.304 143.644 153.556 143.948 153.732C144.252 153.908 144.597 154 144.948 154C145.299 154 145.644 153.908 145.948 153.732C146.252 153.556 146.505 153.304 146.68 153",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.948 149H136.948C136.754 149 136.565 148.944 136.402 148.838C136.24 148.732 136.112 148.582 136.033 148.404C135.955 148.227 135.93 148.031 135.961 147.84C135.992 147.648 136.078 147.47 136.208 147.327C137.538 145.956 138.948 144.499 138.948 140C138.948 139.41 139.035 138.823 139.206 138.258",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.948 134L154.948 154",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.616 135.01C142.52 134.407 143.57 134.06 144.655 134.007C145.74 133.954 146.819 134.197 147.777 134.709C148.735 135.221 149.536 135.984 150.095 136.916C150.653 137.848 150.948 138.914 150.948 140C150.948 142.687 151.718 144.653 152.655 146.05",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 102.223,
    y: 93.0824,
    width: 94,
    height: 94,
    rx: 7,
    transform: "rotate(5 102.223 93.0824)",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 87.2675,
    y: 62.1033,
    width: 142,
    height: 142,
    rx: 7,
    transform: "rotate(10 87.2675 62.1033)",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 80.7092,
    y: 32.6559,
    width: 182,
    height: 182,
    rx: 7,
    transform: "rotate(15 80.7092 32.6559)",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 78.1584,
    y: 1.28171,
    width: 222,
    height: 222,
    rx: 7,
    transform: "rotate(20 78.1584 1.28171)",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateIcon);
export default __webpack_public_path__ + "static/media/empty-state-icon.66ad8e49d9025a0f44054f3f5503ff1d.svg";
export { ForwardRef as ReactComponent };